import React, { useEffect, useState } from "react";
import "./App.css";

import centerIconSvg from "./Assets/square.svg";
import goBackIcon from "./Assets/arrow-back.png";

import backgroundImg from "./Assets/wavy-lines.svg";
import SignIn from "./components/SignIn.jsx";
import SignUp from "./components/SignUp.jsx";
import Verification from "./components/Verification.jsx";
import Oups from "./components/Oups.jsx";
import Loading from "./components/Loading.jsx";
import Ticket from "./components/Ticket.jsx";

import {
  currentYear,
  getLocalStorageData,
  getSourceInAnAddressBar,
  getDeviceIdFromURL,
  handleDataStructure
} from "./config/helpers.js";
import { main_end_point } from "./config/baseUrl.js";

import axios from "axios";

function App() {
  const [signIn, setSignIn] = useState(true);
  const [verification, setVerification] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [oups, setOups] = useState(false);
  const [load, setLoad] = useState(false);
  const [reload, setReload] = useState(0);
  const [help, setHelp] = useState(false);
  const [ticket, setTicket] = useState(false);

  useEffect(() => {
    getSourceInAnAddressBar();
    getDeviceIdFromURL();
    // Cette fonction permet de récupérer des informations dans le localStorage
    let storeData = getLocalStorageData();
    const hash_phone = storeData.kaba_info.neguediourou;

    if (hash_phone && hash_phone !== "") {
      get_otp_active();
    }

    setSignIn(storeData.kaba_info.login.signin);
    setSignUp(storeData.kaba_info.login.signup);
    setVerification(storeData.kaba_info.login.verification);
    setOups(storeData.kaba_info.login.oups);
    setTicket(storeData.kaba_info.ticket.ticket);
    setHelp(storeData.kaba_info.help);
  }, [signIn, signUp, verification, oups, reload, help, ticket]);

  const get_otp_active = () => {
    let storeData = getLocalStorageData().kaba_info;
    let hashed_phone = storeData.neguediourou;

    // Utilisez Axios pour envoyer les données du formulaire au backend
    let data = {
      hashed_phone: hashed_phone,
    };
    axios
      .get(`${main_end_point}/get_active_otp/`, data)
      .then((response) => {
        // Traitez la réponse du backend si nécessaire
        handleDataStructure(response.data.type, "");
        handleDataStructure("one_time_password_id", response.data.otp_id);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const udpadePhoneNumber = () => {
    handleDataStructure("signin", "");
    handleDataStructure("help", false);
    setReload(2);
  };

  const helpMe = () => {
    handleDataStructure("help", true);
    handleDataStructure("ticket", "");
    setReload(3);
  };
  const handleUserReturn = () => {
    if (ticket) {
      udpadePhoneNumber();
    }
    if (signIn) {
      handleDataStructure("ticket", "");
      setReload(6);
    }
  };
  const displayGoBackAnd = () => {
    if (!oups) {
      return help ? (
        <span onClick={udpadePhoneNumber}>Retour sur la page de connexion</span>
      ) : (
        <span onClick={helpMe}>Aide et support</span>
      );
    }
    return;
  };
  const displayGoBack = () => {
    if (!oups) {
      return (
        help && (
          <div className="update-phone-btn">
            <button onClick={handleUserReturn}>
              <img src={goBackIcon} alt="go back" />
              <span>retour</span>{" "}
            </button>
          </div>
        )
      );
    }
  };


  return (
    <div>
      {load ? (
        <Loading />
      ) : (
        <div className="main">
          <div className="container">
            <div className="screen">
              <div className="screen-part-1" id="position-left-block">
                <div>
                  {displayGoBack()}

                  {verification && !help && (
                    <div className="update-phone-btn">
                      <button onClick={udpadePhoneNumber}>
                        <img src={goBackIcon} alt="go back" />
                        <span>Modifier le numéro</span>{" "}
                      </button>
                    </div>
                  )}
                  {signUp &&
                  <div className='update-phone-btn'>
                    <button onClick={udpadePhoneNumber}>
                      <img src={goBackIcon} alt='go back'/>
                      <span>Connexion</span> </button>
                  </div>
                }
                </div>
                <div className="left-block">
                  {ticket && <Ticket componentDidMount={setReload} />}

                  {signIn && <SignIn componentDidMount={setReload} />}
                  {signUp && <SignUp componentDidMount={setReload} />}
                  {verification && (
                    <Verification componentDidMount={setReload} />
                  )}
                  {oups && <Oups componentDidMount={setReload} />}
                </div>
                <div className="copyright">
                  <div>{displayGoBackAnd()}</div>
                  <div>Kabakoo Academies. All rights reserved. © {currentYear()}</div>
                </div>
              </div>


            <div className='screen-part-2' id="block">
              <img className='back-img' src={backgroundImg} />

              <div className='right-block'>
                {/* <div className='background-svg'></div> */}
                <div className='image'>
                  <img src={centerIconSvg} alt='icon' />
                </div>
              </div>
            </div>
          </div>
        </div>
      
    </div>
  )
}
</div>
  )}
export default App;
